//export const API_ROOT = 'https://one-api.vacway.es/v1/'
export const API_ROOT = 'https://one-api-erp.vacway.es/v1/'
export const GMAPS_KEY = 'AIzaSyB50fu9J8shwHYglxAjacSUreJkK9DWr2c'
